import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import './animate.min.css'

import App from './App'

const root = ReactDOM.createRoot(document.getElementById('app')!)

root.render(<App />)
